import React, { useState, useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import SynkinesisQuestionGroup from './SynkinesisQuestionGroup';
import ErrorDialogModal from '../modals/ErrorDialogModal';
import DictionaryContext from '../../../context/dictionaryContext'
import UserPrefContext from '../../../context/userPrefContext'
import AuthContext from '../../../context/authContext';
import PatientContext from '../../../context/patientContext';
import ConfirmDialog from '../shared/ConfirmDialog';
import {BsSignStopFill } from 'react-icons/bs'


function SynkinesisEditModal(props) {

    const panelName = 'synkinesis_assessment_panel'
    const visCtx = useContext(PatientContext);
    const dictCtx = useContext(DictionaryContext)
    const userPrefCtx = useContext(UserPrefContext)
    const authCtx = useContext(AuthContext)

    const [show, setShow] = useState(false);
    const [synkinesisMode, setSynkinesisMode] = useState({mode: 'hide', synkinesis: null})

    const [groups, setGroups] = useState([])
    const [sortedQuestions, setSortedQuestions] = useState([])
    const [modalTitle, setModalTitle] = useState('')
    const [synkinesisValues, setSynkinesisValues] = useState({})
    const [errors, setErrors] = useState([])
    const [showError, setShowError] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false)

    let httpHeaders = (token) => {return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'accept': 'application/json',
        auth: authCtx.authMode,
    }}


    useEffect(() => {
        // console.log("props", props)
        if (dictCtx.dict_intake_form.length > 0) {
            const intakeForm = dictCtx.dict_intake_form.find(form => {
                return form.display_name_short === panelName.replace("_panel","")
            })

            if (intakeForm !== undefined) {
                // setIntakeFormId(intakeForm.id)
                // sort questions by sort_position
                const questions = dictCtx.dict_intake_form_question.filter(quest => {
                    return quest.DictIntakeFormQuestion.dict_intake_form_id === intakeForm.id
                })
                
                const comp = (a,b) => {
                    var agrp = (+a.DictIntakeFormQuestion.group_id) * 100 + (+a.DictIntakeFormQuestion.sort_position)
                    var bgrp = (+b.DictIntakeFormQuestion.group_id) * 100 + (+b.DictIntakeFormQuestion.sort_position)
                    return agrp - bgrp
                }
                // const sortedQuestions = questions.sort((a,b) => a.sort_position - b.sort_postion)
                let sortedQs = questions.sort(comp)
                // console.log("Sorted questions", sortedQs)
                // setSortedQuestions(sortedQs)
                // sortedQs = createQuestions(sortedQs)

                setSortedQuestions(sortedQs)

                // console.log("Sorted questions", sortedQs)

                if (props.mode === 'ipad' && !!props.patient) {
                    // ipad mode - get user name from props.patient
                    setModalTitle(`${intakeForm.display_name} - ${props.patient.last_name}, ${props.patient.first_name}`)
                } else {
                    // "normal mode - take patient details from patient context"
                    setModalTitle(`${intakeForm.display_name} - ${visCtx.pat_last}, ${visCtx.pat_first}`)
                }
                


                // create result object for Synkinesis Assessmentlike {q0:0, q1:0,...}
                // we will use this object to post results
                const fiVals = sortedQs.reduce((accum, element) => {
                    // don't include elements without values (without input elements)
                    if (!!element.DictIntakeFormQuestion.question_type) {
                        accum[element.DictIntakeFormQuestion.display_name_short] = 0
                    }
                    return accum
                }, {})

                // console.log("fiVals", fiVals)
                // console.log("props.mode.synkinesis", props.mode.synkinesis)
                if (props.mode.synkinesis !== null) {
                    setSynkinesisValues(props.mode.synkinesis)
                } else {
                    setSynkinesisValues(fiVals)
                }
                



                // setFormQuestions(sortedQuestions)

                // get group_ids of questions (only one id per group)
                const groups_c = sortedQs
                    .map((value, index, qs) => (index > 0 && qs[index-1].DictIntakeFormQuestion.group_id === value.DictIntakeFormQuestion.group_id) ? null : value.DictIntakeFormQuestion.group_id)
                    .filter(value => value !== null)

                // console.log("groups",groups_c)
                setGroups(groups_c)
            }

            // ipad mode
            if (!!props.mode && props.mode === 'ipad') {
                setShow(true)
            }
        }
    }, [dictCtx.dict_intake_form.length, visCtx, props.mode, props.patient, props.show])


    const valueChanged = (new_values) => {
        // console.log("synkinesisValues", synkinesisValues)
        // console.log("Question value changed! new_values:", new_values)
        setSynkinesisValues({...new_values})
    }



    const saveSynkinesisAssessment = async() => {
        try {
            // console.log("Creating face instruments", JSON.stringify(faceInstrumentValues))
            let synkinesisCreateURL = ''
            let method = 'POST'
            
            if (props.mode === 'ipad' && !!props.patient) {
                // ipad mode - get patient token from props.patient
                synkinesisCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/synkinesis_assessments/from_ipad/${props.patient.form_id}/${props.patient.patient_token}`
            } else {
                // "normal" mode - take patient token from patient context
                
                if (!!props.mode.synkinesis?.id && props.mode.mode === 'edit') {
                    method = "PATCH"
                    synkinesisCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/synkinesis_assessments/${props.mode.synkinesis.id}`
                } else {
                    method = "POST"
                    synkinesisCreateURL = `${process.env.REACT_APP_SERVER}/api/v1/synkinesis_assessments/${visCtx.pat_token}`
                }
            }

            // we need to pass only particular values (important for editing of existing synkinesis - as it has extra values that the API desn't take)
            // const questionTypes = ['select', 'sum', 'saq'];
            const questionTypes = ['select', 'number']; 
            // console.log("SynkinesisEditModal sortedQuestions", sortedQuestions)

            const valuesToInclude = sortedQuestions
                .filter(q => questionTypes.findIndex(qestionType => qestionType === q.DictIntakeFormQuestion.question_type >= 0))
                .map(fq => fq.DictIntakeFormQuestion.display_name_short)
            let valuesToSave = {}

            // console.log("SynkinesisEditModal valuesToInclude", valuesToInclude)

            for (const prop of valuesToInclude) {
                if (synkinesisValues.hasOwnProperty(prop)) {
                    valuesToSave[prop] = synkinesisValues[prop];
                }
            }

            // console.log("SynkinesisEditModal valuesToSave", valuesToSave)
            
            const response = await fetch(synkinesisCreateURL, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userPrefCtx.bearerToken}`,
                    'accept': 'application/json',
                    auth: authCtx.authMode,
                },
                method: method,
                body: JSON.stringify(valuesToSave),
            })

            if (response.status === 200) {
                const responseData = await response.json()
                // console.log("Created Synkinesis Assessment: responseData", responseData)

                if (props.mode.mode === 'edit' || props.mode.mode === 'new') {
                    // change last updated time
                    if (!!props.setLastUpdatedTime) {
                        props.setLastUpdatedTime(new Date().getTime())
                        
                    }
                    props.onSaveOrDelete()
                    props.onClose()
                    // setShow(false)
                } else if (props.mode === 'ipad') {
                    // ipad mode - log out
                    logout()
                }
                

            } else {
                console.log("Failed to create Synkinesis Assessment", response)
                if (!response.ok) {
                    throw new Error('Unprocessable Entity: ' + response.statusText);
               }
            }
        } catch (e) {
            console.log("Failed to create Synkinesis Assessment", e)
            setShowError(true);
        }

    }



    // validate and save changes
    const handleSave = () => {
        // console.log("SynkinesisModal before save", synkinesisValues)

        // make sure we have all values set 
        const keys = Object.keys(synkinesisValues)

        // console.log("synkinesisValues keys", keys)

        const errorsArr = keys.filter((key) => {
            return synkinesisValues[key] === 0 
        })

        // console.log("errorsArr ", errorsArr)

        setErrors(errorsArr)

        // console.log("Errors - missing values in questions", errorsArr)

        // if errors array is empty then all fields populated; otherwise some are not
        if (errorsArr.length === 0) {
            saveSynkinesisAssessment()            
        }        
    }




    const handleDelete = (e) => {
        setShowConfirm(true)   
    }


    const deleteSynkinesis = async (synkinesis_id) => {
        const url = `${process.env.REACT_APP_SERVER}/api/v1/synkinesis_assessments/${synkinesis_id}`
        try {
            const response = await fetch(url, {
                headers: httpHeaders(userPrefCtx.bearerToken),
                method: "DELETE",
            })

            if (response.status === 200) {
                const responseData = await response.json()
                if (!!props.setLastUpdatedTime) {
                    props.setLastUpdatedTime(new Date().getTime())
                    
                }
                props.onSaveOrDelete()
                props.onClose()
            } else {
                console.log("Failed to delete Synkinesis Assessment", response)
                if (!response.ok) {
                    throw new Error('Unprocessable Entity: ' + response.statusText);
               }
            }
        } catch (e) {
            console.log("Failed to delete Synkinesis Assessment", e)
            setShowError(true);
        }
    }



    const closeConfirmDialog = (result) => {
        setShowConfirm(false)
        if (result === 'confirm') {
            if (props.mode.synkinesis !== null && props.mode.synkinesis.id !==null) {
                deleteSynkinesis(props.mode.synkinesis.id)
                props.onClose()
            }

        }
    }


    // temp func to format questions - should be changed on the server (database)
    const createQuestions = (qs) => {
        const qNames = ["q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8", "q9"]
        let newQs = qs.map(q => {
            if (qNames.findIndex(qn => qn === q.DictIntakeFormQuestion.display_name_short) >= 0) {
                // reformat qs
                return {
                    ...q, DictIntakeFormQuestion: 
                    {...q.DictIntakeFormQuestion, mapped_property: q.DictIntakeFormQuestion.display_name_short, question_type: "select", question_option_values: [1,2,3,4,5]}
                }
            } else if(q.DictIntakeFormQuestion.display_name ==="Sum of Scores I-IX") {
                return {
                    ...q, DictIntakeFormQuestion: 
                    {...q.DictIntakeFormQuestion, display_name_short: "sum_of_scores", question_type: "sum", question_option_values:["q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8", "q9"]}
                }
            } else if(q.DictIntakeFormQuestion.display_name ==="SAQ Total Score") {
                return {
                    ...q, DictIntakeFormQuestion: 
                    {...q.DictIntakeFormQuestion, display_name_short: "saq_total_score", question_type: "saq", question_option_values: "s1x100/45"}
                }
            } else {
                return q;
            }
        })
        return newQs;
    }

    return (
        <>
            <ErrorDialogModal
                setOpen={showError}
                close={() => setShowError(false)}
                componentName="Synkinesis Assessment"
            />
            <ConfirmDialog 
                show={showConfirm}
                title='Please confirm'
                modal_class='delete-confirm-modal'
                title_class='delete-confirm-title'
                footer_class='delete-confirm-title'
                prompt='The synkinesis assessment will be permamently deleted. Are you sure you want to delete it? '
                prompt_class='diags-modal-delete-confirm-prompt'
                // cancel_button_text='Do not delete!'
                confirm_button_text='Delete'
                confirm_button_variant='danger'
                onClose={(result) => closeConfirmDialog(result)}
                icon={<BsSignStopFill />}
                iconColor='red'
                iconSize='1.3em'
            />
            <Modal size="fullscreen" show={props.mode.mode === 'new' || props.mode.mode === 'edit'} onHide={props.onClose} animation={false}
                style={{ visibility: (showError) ? 'hidden' : 'visible' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title><h4>{modalTitle}</h4></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        {groups.map((group_id, index) => 
                            <SynkinesisQuestionGroup 
                                key={index}
                                group_id={group_id}
                                // questions={sortedQuestions.filter(q => q.DictIntakeFormQuestion.group_id === group_id)}
                                // questions={createQuestions(sortedQuestions.filter(q => q.DictIntakeFormQuestion.group_id === group_id))}
                                questions={sortedQuestions.filter(q => q.DictIntakeFormQuestion.group_id === group_id)}
                                onChange={valueChanged}
                                errors={errors}
                                values={synkinesisValues}
                            />
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer className='justify-content-between'>
                    <div className='w-100'>
                        {errors.length > 0 && <span style={{color:'red', fontWeight:'bold'}} className='text-danger font-weight-bold'>All fields must be populated!</span>}
                    </div>
                    
                    <div className="inline-block text-left">
                        <Button className='mx-2' variant="secondary" onClick={props.onClose}>
                            {props.mode.mode === 'ipad' ? 'Logout' : 'Close'}
                        </Button>
                        {props.mode.mode !== 'ipad' && props.mode.synkinesis !== null &&
                        <Button className='mx-2' variant="danger" onClick={handleDelete}>
                            Delete
                        </Button>
                        }
                    </div>
                    <div className='inline-block text-right'>
                        <Button className='mx-2' variant="primary" onClick={handleSave}>
                            Save Changes
                        </Button>
                    </div>
                    
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default SynkinesisEditModal
